// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"155":"492e7a0d","369":"7f451476","427":"cb9e8efb"}[chunkId] + ".chunk.js";
};